import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { QuickStatsComponent } from '../quick-stats/quick-stats.component';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import * as _ from 'underscore';

@Component({
	selector: 'app-preroll-quick-stats',
	templateUrl: './preroll-quick-stats.component.html',
	styleUrls: ['./preroll-quick-stats.component.css']
})
export class PrerollQuickStatsComponent extends QuickStatsComponent implements OnInit, OnDestroy {
	@Input() legend: any;
	public legends = null;
	public youtubeViewsPermission: boolean;
	public youtubeViewsPermissionCheck: object = { permission: { flags: ['hasYoutubeViews'] } };

	constructor(protected analyticsService: AnalyticsService, protected analyticsDataModel: AnalyticsDataModel) {
		super(analyticsService, analyticsDataModel);
	}

	ngOnInit() {
		super.ngOnInit();
		if (this.legend) {
			this.legends = JSON.parse(decodeURI(this.legend));
			this.legends = _.filter(this.legends, (item) => {
				return this.analyticsDataModel.checkComponentForPermission(item);
			});
		}
		this.youtubeViewsPermission = this.analyticsDataModel.checkComponentForPermission(this.youtubeViewsPermissionCheck);
	}

	ngOnDestroy() {
		super.ngOnDestroy();
	}

	requestData() {
		super.requestData();
	}

	processResponseData(response: any) {
		const impressions = UtilityService.isUndefinedOrNull(response[0].impressions) ? 0 : response[0].impressions;
		const completions = UtilityService.isUndefinedOrNull(response[0].completions) ? 0 : response[0].completions;
		const totalVisits = UtilityService.isUndefinedOrNull(response[0].total_visits) ? 0 : response[0].total_visits;
		const viewThroughs = UtilityService.isUndefinedOrNull(response[0].view_throughs) ? 0 : response[0].view_throughs;
		const clicks = UtilityService.isUndefinedOrNull(response[0].clicks) ? 0 : response[0].clicks;
		const youtubeviews = UtilityService.isUndefinedOrNull(response[0].youtube_verified_imprs)
			? 0
			: response[0].youtube_verified_imprs;

		const completionsPercentage = UtilityService.isUndefinedOrNull(response[0].completions_percent)
			? '-- '
			: parseFloat(response[0].completions_percent).toFixed(2);
		const visitsPercentage = UtilityService.isUndefinedOrNull(response[0].total_visits_percent)
			? '-- '
			: parseFloat(response[0].total_visits_percent).toFixed(2);
		const viewThroughsPercentage = UtilityService.isUndefinedOrNull(response[0].view_throughs_percent)
			? '-- '
			: parseFloat(response[0].view_throughs_percent).toFixed(2);
		const clicksPercentage = UtilityService.isUndefinedOrNull(response[0].clicks_percent)
			? '-- '
			: parseFloat(response[0].clicks_percent).toFixed(2);
		const youtubeViewsPercentage = UtilityService.isUndefinedOrNull(response[0].youtube_verified_imprs_rate)
			? '-- '
			: parseFloat(response[0].youtube_verified_imprs_rate).toFixed(2);

		this.quickStatsData = {
			impressions: impressions,
			completions: completions,
			totalVisits: totalVisits,
			viewThroughs: viewThroughs,
			clicks: clicks,
			completionsPercentage: completionsPercentage,
			visitsPercentage: visitsPercentage,
			viewThroughsPercentage: viewThroughsPercentage,
			clicksPercentage: clicksPercentage
		};

		if (this.youtubeViewsPermission) {
			this.quickStatsData['youtubeviews'] = youtubeviews;
			this.quickStatsData['youtubeViewsPercentage'] = youtubeViewsPercentage;
		}
	}
}
